import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { ROUTES } from 'shared/constants';

import ControllerIcon from 'assets/controller-brown.svg?react';
import defeatIcon from 'assets/png/defeat-player-card.png';
import victoryIcon from 'assets/png/victory-player-card.png';

interface NewFinishViewProps {
  isWinner: boolean;
  showModal?: boolean;
}

export const NewFinishView = ({ isWinner, showModal }: NewFinishViewProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <img src={isWinner ? victoryIcon : defeatIcon} alt="" className={`w-[65%]`} />
      {showModal && (
        <div className="w-[86%] max-w-[550px] bg-violet rounded-[20px] border-solid border-border border p-5 flex flex-col gap-4 xlg:gap-8 items-start justify-start relative">
          <div className="flex flex-col gap-4 items-start justify-start self-stretch shrink-0 relative">
            <div className="text-white text-left  text-2xl leading-8 font-semibold relative self-stretch">
              {isWinner ? t('finishView.winTitle') : t('finishView.loseTitle')}
            </div>
            <div className="text-white text-left  text-base  font-normal relative self-stretch">
              {isWinner ? t('finishView.winText') : t('finishView.loseText')}
            </div>
          </div>
          <PrimaryButton
            onClick={() => {
              navigate(ROUTES.LOBBY);
            }}
            svg={<ControllerIcon className="w-5 h-5 sm:w-6 sm:h-6" />}
            text={t('finishView.playAgain')}
            className="mt-4 w-full"
          />
        </div>
      )}
    </>
  );
};
